import { AbstractListReducer } from '../abstract/reducer';

export default class Reducer extends AbstractListReducer {
  constructor({ actioner, initialState }) {
    super({ initialState, actioner });
  }
}
